import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ContractsCommonService } from '../../service/contract-creation/contracts-common.service';
import { Subscription } from 'rxjs';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-country-info',
  templateUrl: './country-info.component.html',
  styleUrls: ['./country-info.component.scss'],
  standalone: false
})
export class CountryInfoComponent implements OnDestroy {
  @ViewChild('countryTable') countryTable!: Table;

  visible: boolean = false;
  countriesDetails: any;
  searchTerm: string = '';
  private subscription: Subscription = new Subscription();
  constructor(
    private contractCommonService: ContractsCommonService,
    private messageService: MessageService
  ) {
    const cachedPorts = this.contractCommonService.getPortUnlocSync();
    if (cachedPorts) {
      this.processPortsData(cachedPorts);
    } else {
      console.log('Fetching ports details...');
      this.subscription.add(
        this.contractCommonService.portUnloc$.subscribe((response: any) => {
          if (response) {
            this.processPortsData(response);
          }
        })
      );

      this.subscription.add(
        this.contractCommonService.getAllPorts().subscribe({
          next: (response: any) => {
            if (response && response.data) {
              this.processPortsData(response.data);
            }
          },
          error: (error) => {
            console.error('Error fetching ports:', error);
          }
        })
      );
    }
  }

  private processPortsData(portsDetails: any): void {
    this.countriesDetails = Array.from(
      new Map(
        portsDetails.map((port: any) => [
          port.countryCode,
          { country: port.country, countryCode: port.countryCode }
        ])
      ).values()
    );
  }

  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Copied to clipboard: ' + value
      });
    }).catch(err => {
      console.error('Error copying text: ', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy text.'
      });
    });
  }

  downloadTableData(): void {
    const csvData = this.convertToCSV(this.countriesDetails);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'country_code_details.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(data: any[]): string {
    if (!data || !data.length) {
      return '';
    }

    const headers = ['Country Name', 'Country Code'];
    const rows = data.map(row => [
      this.escapeCSVValue(row.country),
      this.escapeCSVValue(row.countryCode)
    ]);

    const csvRows = rows.map(row => row.join(','));
    return [headers.join(','), ...csvRows].join('\n');
  }

  private escapeCSVValue(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }

  resetFilters(): void {
    this.searchTerm = '';
    if (this.countryTable) {
      this.countryTable.clear();
      this.countryTable.filterGlobal(this.searchTerm, 'contains');
      this.countryTable.reset();
      this.countryTable.rows = 10;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}